// extracted by mini-css-extract-plugin
export default {"characterItem":"CharacterItem_characterItem__zsAbn"};